// ================ Action types ================ //

import { storableError } from "../../util/errors";
import { createImageVariantConfig } from "../../util/sdkLoader";
import { parse } from "../../util/urlHelpers";
import { fetchMatchedListings } from "../ManageListingsPage/ManageListingsPage.duck";

export const MATCHEDLISTINGS_REQUEST = 'app/MatchedListingsPage/MATCHEDLISTINGS_REQUEST';
export const MATCHEDLISTINGS_SUCCESS = 'app/MatchedListingsPage/MATCHEDLISTINGS_SUCCESS';
export const MATCHEDLISTINGS_ERROR = 'app/MatchedListingsPage/MATCHEDLISTINGS_ERROR';

export const CURRENTLISTING_REQUEST = 'app/MatchedListingsPage/CURRENTLISTING_REQUEST';
export const CURRENTLISTING_SUCCESS = 'app/MatchedListingsPage/CURRENTLISTING_SUCCESS';
export const CURRENTLISTING_ERROR = 'app/MatchedListingsPage/CURRENTLISTING_ERROR';

// ================ Reducer ================ //

const initialState = {
    currentListing: null,
    currentListingInProgress: false,
    currentListingError: null,
    MatchedListings: null,
    MatchedListingsInProgress: false,
    MatchedListingsShowError: null,
};

export default function reducer(state = initialState, action = {}) {
    const { type, payload } = action;
    switch (type) {
        case MATCHEDLISTINGS_REQUEST:
            return { ...state, MatchedListingsInProgress: true, MatchedListingsShowError: null };
        case MATCHEDLISTINGS_SUCCESS:
            return { ...state, MatchedListingsInProgress: false, MatchedListings: payload };
        case MATCHEDLISTINGS_ERROR:
            console.error(payload);
            return { ...state, MatchedListingsInProgress: false, MatchedListingsShowError: payload };

        case CURRENTLISTING_REQUEST:
            return { ...state, currentListingInProgress: true, currentListingShowError: null };
        case CURRENTLISTING_SUCCESS:
            return { ...state, currentListingInProgress: false, currentListing: payload };
        case CURRENTLISTING_ERROR:
            console.error(payload);
            return { ...state, currentListingInProgress: false, currentListingError: payload };
        default:
            return state;
    }
}

// ================ Selectors ================ //

// ================ Action creators ================ //

export const MatchedListingsRequest = () => ({ type: MATCHEDLISTINGS_REQUEST , MatchedListings: []});

export const MatchedListingsSuccess = user => ({
    type: MATCHEDLISTINGS_SUCCESS,
    payload: user,
});

export const MatchedListingsError = e => ({
    type: MATCHEDLISTINGS_ERROR,
    payload: e,
    error: true,
});

export const CurrentListingRequest = () => ({ type: CURRENTLISTING_REQUEST , payload:[]});

export const CurrentListingSuccess = user => ({
    type: CURRENTLISTING_SUCCESS,
    payload: user,
});

export const CurrentListingError = e => ({
    type: CURRENTLISTING_ERROR,
    payload: e,
    error: true,
});

// ================ Thunks ================ //



const keyFromListing = l => {
    const role = l?.attributes?.publicData?.roles?.[0];
    const title = role?.label;
    const specialties = role?.specialties || role?.specialtiesArray || [];
    const tools = role?.favouriteToolArray || role?.favouriteTool || [];

    if (!title) return null;
    const normalizedTitle = String(title)
        .toLowerCase()
        .replace(/-/g, ' ')
        .trim();

    return `${normalizedTitle}|${JSON.stringify(specialties)}|${JSON.stringify(tools)}`;
};


export const CurrentCompanyListing = (id) => async (dispatch, getState, sdk) => {
  dispatch(CurrentListingRequest());
  dispatch(MatchedListingsSuccess([]));

      let { matchedByKey } = getState().ManageListingsPage;
  try {
    const res = await sdk.listings.show({
      id,
      include: ['author'],
      'fields.user': ['profile'],
    });

    const currentListing = res?.data?.data;
    dispatch(CurrentListingSuccess(currentListing));
    const constructedKey = keyFromListing(currentListing);
    let matchedData = matchedByKey?.[constructedKey];
    let matchedListingIds = matchedData?.matchedListingIds || [];

    if (!matchedListingIds.length) {
      await dispatch(fetchMatchedListings({ listings: currentListing }));
      matchedByKey = getState().ManageListingsPage.matchedByKey;
      matchedData = matchedByKey?.[constructedKey];
      matchedListingIds = matchedData?.matchedListingIds || [];
    }
    if (matchedListingIds?.length > 0) {
      await dispatch(MatchedListings(matchedListingIds));
    } else {
      dispatch(MatchedListingsSuccess([]));
    }
  } catch (error) {
    dispatch(CurrentListingError(storableError(error)));
  }
};

export const MatchedListings = (ids) => async (dispatch, getState, sdk) => {
    dispatch(MatchedListingsRequest());
    const params = {
        ids,
        include: ['author', 'author.profileImage', 'images', 'currentStock'],
    };
    try {
        const res = await sdk.listings.query(params);
        const fetchedListings = res?.data?.data || [];

        const orderedListings = ids
            .map(id => fetchedListings?.find(l => l?.id?.uuid === id))
            .filter(Boolean);
        dispatch(MatchedListingsSuccess(orderedListings))
    } catch (error) {
        dispatch(MatchedListingsError(storableError(error)));
    }
}

export const loadData = (params, search, config) => async (dispatch, getState, sdk) => {
    const id = params.id
    const queryParams = parse(search, {
        latlng: ['origin'],
        latlngBounds: ['bounds'],
    });
    const { page = 1, address, origin, ...rest } = queryParams;
    return dispatch(CurrentCompanyListing(id));
};


